/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as actionTypes from './actionTypes';

const initialState = {
  context: {}, //context for the try it out panel
  initializingChat: false,
  open: false, //used to determine if the try it out panel is open/closed
  messages: [] //the ids of the messages, this list is ordered.
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TRY_IT_RESET_CHAT:
      return { ...initialState, open: state.open };
    case actionTypes.TRY_IT_INITIALIZE_CHAT_START:
    case actionTypes.TRY_IT_SEND_MESSAGE_START:
      return {
        ...state,
        context: action.context,
        messages: [...state.messages, action.messageId],
        initializingChat: true,
        skipTraining: action.skipTraining
      };
    case actionTypes.TRY_IT_INITIALIZE_CHAT_SUCCESS:
    case actionTypes.TRY_IT_SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        context: action.context,
        initializingChat: false,
        skipTraining: action.skipTraining
      };
    case actionTypes.TRY_IT_SEND_MESSAGE_ERROR:
    case actionTypes.TRY_IT_INITIALIZE_CHAT_ERROR:
      return {
        ...state,
        initializingChat: false,
        context: action.context
      };
    default:
      break;
  }
  return state;
};
